import { z } from "zod"

export const AgencySchema = z.object({
  id: z.number(),
  name: z.string(),
  cover: z.string().nullable(),
  logo: z.string(),
})

export const DashboardUserSchema = z.object({
  id: z.number(),
  username: z.string(),
  fullName: z.string(),
  avatar: z.string().nullable(),
  agency: AgencySchema,
})

export const EventSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  date_start: z.string(),
  date_end: z.string(),
})

export const VisitSchema = z.object({
  id: z.number(),
  agency_id: z.number(),
  date: z.string(),
  reason: z.string(),
})

export const IntegrationSchema = z.object({
  id: z.number(),
  type: z.number(),
  user: z.string().nullable(),
  pass: z.string().nullable(),
  enabled: z.boolean(),
  type_label: z.string(),
  description: z.string(),
  url: z.string(),
  icon: z.string(),
  auth_type: z.string(),
  controller_action: z.string().nullable(),
  extra_fields: z.any().nullable(),
})

export const ExtraCardSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  url: z.string(),
  icon: z.string(),
  auth_type: z.string(),
  type_label: z.string(),
})

export const SupplierSchema = z.object({
  id: z.number(),
  link: z.string(),
  description: z.string(),
  image: z.string().nullable(),
})

export const HighlightSchema = z.object({
  id: z.number(),
  link: z.string(),
  image: z.string().nullable(),
})

export const DocumentSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  url: z.string(),
})

export const DashboardSchema = z.object({
  user: DashboardUserSchema,
  eventos: z.array(EventSchema),
  nextVisits: z.array(VisitSchema),
  integrations: z.array(IntegrationSchema),
  suppliers: z.array(SupplierSchema),
  highlights: z.array(HighlightSchema),
  commercials: z.array(HighlightSchema),
  documents: z.array(DocumentSchema),
  extraCards: z.array(ExtraCardSchema),
})

export type Agency = z.infer<typeof AgencySchema>
export type DashboardUser = z.infer<typeof DashboardUserSchema>
export type Event = z.infer<typeof EventSchema>
export type Visit = z.infer<typeof VisitSchema>
export type Integration = z.infer<typeof IntegrationSchema>
export type ExtraCard = z.infer<typeof ExtraCardSchema>
export type Supplier = z.infer<typeof SupplierSchema>
export type Highlight = z.infer<typeof HighlightSchema>
export type Document = z.infer<typeof DocumentSchema>
export type DashboardData = z.infer<typeof DashboardSchema>